import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Auth } from "./Authentication";

function PublicFooter() {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
}

export default PublicFooter;
